<template>
  <div class="bing_mobile_box">
    <div class="bing_mobile_box_head">
      <div class="title">绑定手机号</div>
      <div class="wording">首次登录企业投票云服务，请绑定手机</div>
    </div>
    <div class="bing_mobile_box_main">
      <el-form
        :model="registerRuleForm"
        :rules="registerRules"
        ref="registerRuleForm"
        label-width="0px"
      >
        <el-form-item label="" prop="PhoneNumber">
          <el-input
            type="text"
            v-model="registerRuleForm.PhoneNumber"
            placeholder="请输入手机号"
            prefix-icon="el-icon-user-solid"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="" prop="PassWord">
          <el-input
            type="text"
            v-model="registerRuleForm.PassWord"
            placeholder="设置密码"
            prefix-icon="el-icon-lock"
            clearable
            show-password
          ></el-input>
          <em>密码强度：</em>
          <el-progress
            :stroke-width="10"
            :percentage="progressPercentage"
            :color="progressCustomColor"
            :format="passwordStrengthFormat"
            style="width: 60%"
          ></el-progress>
        </el-form-item>
        <el-form-item label="" prop="confirmPassword">
          <el-input
            type="text"
            v-model="registerRuleForm.confirmPassword"
            placeholder="确认密码"
            prefix-icon="el-icon-key"
            clearable
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item label="" prop="VerificationCode">
          <el-input
            type="text"
            v-model="registerRuleForm.VerificationCode"
            maxlength="4"
            placeholder="验证码"
            style="float: left; width: 50%"
          ></el-input>
          <el-image
            style="float: right; width: 20%; margin-right: 29%; height: 30px"
            :src="imageCode"
            fit="fill"
            @click="getImageCode()"
          >
            <div slot="error" class="image-slot">
              <span>加载中…</span>
            </div>
          </el-image>
        </el-form-item>
        <el-form-item label="" prop="PhoneCode">
          <el-input
            type="text"
            v-model="registerRuleForm.PhoneCode"
            maxlength="4"
            placeholder="短信验证码"
            style="float: left; width: 50%"
          ></el-input>
          <el-button
            style="float: right; width: 30%; margin-right: 19%"
            v-on:click="sendPhoneCode()"
          >
            获取验证码
          </el-button>
          <br />
          <span v-if="showPhoneCodeMessage">
            短信验证码已发送，请您在5分钟内填写。
          </span>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            class="login-submit-btn"
            v-on:click="submitRegisterForm('registerRuleForm')"
            round
          >
            登录
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    const reg = /(?!^(\d+|[a-zA-Z]+|[~!@#$%^&*?]+)$)^[\w~!@#$%^&*?]{6,13}$/
    var validateNewPwd = (rule, value, callback) => {
      if (!reg.test(value)) {
        callback(new Error('密码应是6-13位数字、字母或字符！'))
      } else {
        callback()
      }
    }
    const validateComfirmPwd = (rule, value, callback) => {
      if (!reg.test(value)) {
        callback(new Error('密码应是6-13位数字、字母或字符！'))
      } else if (this.registerRuleForm.PassWord !== value) {
        callback(new Error('确认密码与新密码不一致！'))
      } else {
        callback()
      }
    }
    const phoneReg = /^1[0-9]{10}$/
    const validatePhone = (rule, value, callback) => {
      if (!phoneReg.test(value)) {
        callback(new Error('手机号码格式不正确'))
      } else {
        callback()
      }
    }
    return {
      registerRuleForm: {
        PhoneNumber: null,
        PassWord: null,
        PhoneCode: null,
        PhoneEncryptCode: null,
        PhoneEncryptExpireTime: null,
        EncryptPhoneNumber: null,
        VerificationCode: null,
        EncryptCode: null
      },
      registerRules: {
        PhoneNumber: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }
        ],
        PassWord: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: validateNewPwd, trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请输入确认密码', trigger: 'blur' },
          { validator: validateComfirmPwd, trigger: 'blur' }
        ],
        VerificationCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { min: 4, max: 4, message: '请输入正确的验证码', trigger: 'blur' }
        ],
        PhoneCode: [
          { required: true, message: '请输入短信验证码', trigger: 'blur' },
          { min: 4, max: 4, message: '请输入正确的短信验证码', trigger: 'blur' }
        ]
      },
      progressPercentage: 0,
      progressCustomColor: '#fff',
      imageCode: '',
      verificationPhoneCode: {
        EncryptCode: '',
        InputCode: '',
        PhoneNumber: ''
      },
      showPhoneCodeMessage: false
    }
  },
  methods: {
    passwordStrengthFormat: function (percentage) {
      if (percentage <= 33) { return '弱' }
      if (percentage > 33 && percentage <= 66) { return '中' }
      if (percentage > 66 && percentage <= 100) { return '强' }
    },
    checkStrong (val) {
      let lv = 0
      if (val.match(/[a-z]/g)) { lv++ }
      if (val.match(/[0-9]/g)) { lv++ }
      if (val.match(/(.[^a-z0-9])/g)) { lv++ }
      if (val.length < 6) { lv = 0 }
      if (lv > 3) { lv = 3 }

      return lv
    },
    getImageCode: function () {
      const _this = this
      _this.registerLoading = true
      _this.$api.verificationCode.getImageCode().then(data => {
        _this.imageCode = 'data:image/png;base64,' + data.ImageCode
        _this.verificationPhoneCode.EncryptCode = data.EncryptCode
        _this.registerLoading = false
      }).catch(err => {
        _this.registerLoading = false
        return err
      })
    },
    sendPhoneCode () {
      const _this = this
      const openLoading = _this.openLoading()
      _this.$refs.registerRuleForm.validateField('PhoneNumber', validError => {
        if (!validError) {
          _this.$refs.registerRuleForm.validateField('VerificationCode', validError => {
            if (!validError) {
              _this.verificationPhoneCode.InputCode = _this.registerRuleForm.VerificationCode
              _this.verificationPhoneCode.PhoneNumber = _this.registerRuleForm.PhoneNumber
              _this.$api.verificationCode.sendPhoneCode(_this.verificationPhoneCode).then(data => {
                // alert(data.Code)
                _this.registerRuleForm.PhoneEncryptCode = data.EncryptCode
                _this.registerRuleForm.PhoneEncryptExpireTime = data.EncryptExpireTime
                _this.registerRuleForm.EncryptPhoneNumber = data.EncryptPhoneNumber
                _this.showPhoneCodeMessage = true
                setTimeout(function () {
                  _this.showPhoneCodeMessage = false
                }, 60000)

                openLoading.close()
              }).catch(err => {
                openLoading.close()
                return err
              })
            } else {
              openLoading.close()
              return false
            }
          })
        } else {
          openLoading.close()
          return false
        }
      })
    },
    submitRegisterForm (formName) {
      const _this = this
      const openLoading = _this.openLoading()
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          if (window.localStorage.getItem('wx_access_token')) {
            const wxAccessToken = JSON.parse(window.localStorage.getItem('wx_access_token'))
            const params = new URLSearchParams()
            params.append('grant_type', 'password')
            params.append('login_mode', 'wechat_register')
            params.append('wx_access_token', wxAccessToken.access_token)
            params.append('unionid', wxAccessToken.unionid)
            params.append('openid', wxAccessToken.openid)
            params.append('PhoneNumber', _this.registerRuleForm.PhoneNumber)
            params.append('PassWord', _this.registerRuleForm.PassWord)
            params.append('VerificationCode', _this.registerRuleForm.VerificationCode)
            params.append('EncryptCode', _this.verificationPhoneCode.EncryptCode)
            params.append('PhoneCode', _this.registerRuleForm.PhoneCode)
            params.append('PhoneEncryptExpireTime', _this.registerRuleForm.PhoneEncryptExpireTime)
            params.append('PhoneEncryptCode', _this.registerRuleForm.PhoneEncryptCode)
            params.append('EncryptPhoneNumber', _this.registerRuleForm.EncryptPhoneNumber)
            _this.$api.account.login(params).then(data => {
              const saveParam = {
                token: data.access_token,
                token_type: data.token_type,
                refresh_token: data.refresh_token,
                expires_in: data.expires_in,
                issued: data['.issued'],
                expires: data['.expires'],
                role: 'user',
                rememberClient: false
              }
              _this.$store.commit('ADD_ACCOUNT', saveParam)
              window.localStorage.removeItem('wx_access_token')
              _this.$router.push({ path: '/meetingList' })
              openLoading.close()
              _this.$message({
                type: 'success',
                message: '登录成功！',
                customClass: 'custom_message_box'
              })
            }).catch(err => {
              openLoading.close()
              return err
            })
          } else {
            openLoading.close()
            _this.$message({
              type: 'warning',
              message: '请先扫码登录',
              customClass: 'custom_message_box'
            })
          }
        } else {
          openLoading.close()
          return false
        }
      })
    }
  },
  watch: {
    'registerRuleForm.PassWord': {
      handler (newValue, oldValue) {
        const lv = this.checkStrong(newValue)
        if (lv === 1) {
          this.progressPercentage = 33
          this.progressCustomColor = '#F56C6C'
        } else if (lv === 2) {
          this.progressPercentage = 66
          this.progressCustomColor = '#E6A23C'
        } else if (lv === 3) {
          this.progressPercentage = 100
          this.progressCustomColor = '#409EFF'
        } else {
          this.progressPercentage = 0
          this.progressCustomColor = '#eee'
        }
      }
    }
  },
  created () {
    const _this = this
    _this.getImageCode()
  }
}
</script>

<style lang="less">
.bing_mobile_box {
  margin: 0px;
  height: 100%;
  width: 100%;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
}
.bing_mobile_box_head {
  width: 100%;
  flex-shrink: 0;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
}
.bing_mobile_box_head .title {
  padding: 40px 0px 0px 0px;
  font-size: 32px;
}
.bing_mobile_box_head .wording {
  color: #444444;
  padding: 6px 0px 30px 0px;
  font-size: 16px;
}
.bing_mobile_box_main {
  padding: 25px 0px 0px 0px;
  width: 100%;
  background-color: #fff;
  flex-grow: 2;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
}
.login-submit-btn {
  width: 100%;
  border-radius: 6px;
  font-size: 16px;
  border: 0;
  letter-spacing: 18px;
}
</style>
